module.exports = __webpack_public_path__ + "img/spiel5.09318dd6.jpg";